export default "__VITE_ASSET__CqYXMOLi__"